// API配置文件
const isDevelopment = process.env.NODE_ENV === 'development';

// 根据环境确定API地址
export const BASE_URL = process.env.VUE_APP_API_URL || (
  isDevelopment 
    ? 'https://api.halloai.tech'  // 开发环境默认API地址
    : 'https://api.halloai.tech'  // 生产环境默认API地址
);

const resolveWsBaseUrl = (url) => {
  if (url.startsWith('ws://') || url.startsWith('wss://')) {
    return url.replace(/\/$/, '');
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${protocol}//${window.location.host}${path}`.replace(/\/$/, '');
};

export const WS_BASE_URL = resolveWsBaseUrl(
  process.env.VUE_APP_WS_URL || 'wss://api.halloai.tech:8800/ws'
);

// API请求超时时间
export const TIMEOUT = 30000;

// 导出环境信息（方便调试）
export const ENV_INFO = {
  mode: process.env.NODE_ENV || 'production',
  baseUrl: BASE_URL,
  wsBaseUrl: WS_BASE_URL,
  isDev: isDevelopment
}; 
